import { JsonProperty, JsonObject } from 'json2typescript';
import { ModelObject } from '@hermes/api-model-core';
import { Edito } from '@hermes/api-model-editorial';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * This class define banner properties
 * @dynamic
 */
let BannerItem = class BannerItem extends ModelObject {
    constructor(source) {
        super();
        this.active = undefined;
        this.link = undefined;
        this.cookieTimestamp = undefined;
        this.content = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("active", Boolean, true),
    __metadata("design:type", Boolean)
], BannerItem.prototype, "active", undefined);
__decorate([
    JsonProperty("link", String, true),
    __metadata("design:type", String)
], BannerItem.prototype, "link", undefined);
__decorate([
    JsonProperty("cookie_timestamp", Number, true),
    __metadata("design:type", Number)
], BannerItem.prototype, "cookieTimestamp", undefined);
__decorate([
    JsonProperty("content", String, true),
    __metadata("design:type", String)
], BannerItem.prototype, "content", undefined);
BannerItem = __decorate([
    JsonObject("BannerItem"),
    __metadata("design:paramtypes", [Object])
], BannerItem);

/**
 * This class define banners data properties
 */
let BannersData = class BannersData extends ModelObject {
    constructor() {
        super();
        this.cookie = undefined;
        this.notifications = undefined;
        this.geofiltering = undefined;
    }
};
__decorate([
    JsonProperty("cookie", BannerItem, true),
    __metadata("design:type", BannerItem)
], BannersData.prototype, "cookie", undefined);
__decorate([
    JsonProperty("notifications", [BannerItem], true),
    __metadata("design:type", Array)
], BannersData.prototype, "notifications", undefined);
__decorate([
    JsonProperty("geofiltering", BannerItem, true),
    __metadata("design:type", BannerItem)
], BannersData.prototype, "geofiltering", undefined);
BannersData = __decorate([
    JsonObject("BannersData"),
    __metadata("design:paramtypes", [])
], BannersData);

var MenuEntryType;
(function (MenuEntryType) {
    MenuEntryType["gridMenuEntry"] = "grid";
    MenuEntryType["landitoMenuEntry"] = "landito";
    MenuEntryType["ecommerceStoryMenuEntry"] = "ecommerce_story";
    MenuEntryType["storyMenuEntry"] = "story";
    MenuEntryType["separatorMenuEntry"] = "line_separator";
})(MenuEntryType || (MenuEntryType = {}));

/**
 * @dynamic
 */
let GridMenuEntry = class GridMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.pimCode = undefined;
        this.hasVisibleProducts = undefined;
        this.edito = new Edito();
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "tid", undefined);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "parentId", undefined);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "type", undefined);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "eventType", undefined);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "name", undefined);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "path", undefined);
__decorate([
    JsonProperty("pimCode", String, true),
    __metadata("design:type", String)
], GridMenuEntry.prototype, "pimCode", undefined);
__decorate([
    JsonProperty("hasVisibleProducts", Boolean, true),
    __metadata("design:type", Boolean)
], GridMenuEntry.prototype, "hasVisibleProducts", undefined);
__decorate([
    JsonProperty("edito", Edito, true),
    __metadata("design:type", Edito)
], GridMenuEntry.prototype, "edito", undefined);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], GridMenuEntry.prototype, "menuEntryList", undefined);
GridMenuEntry = __decorate([
    JsonObject("GridMenuEntry"),
    __metadata("design:paramtypes", [Object])
], GridMenuEntry);

/**
 * @dynamic
 */
let LanditoMenuEntry = class LanditoMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.gridPath = undefined;
        this.pimCode = undefined;
        this.hasVisibleProducts = undefined;
        this.edito = new Edito();
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "tid", undefined);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "parentId", undefined);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "type", undefined);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "eventType", undefined);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "name", undefined);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "path", undefined);
__decorate([
    JsonProperty("gridPath", String, true),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "gridPath", undefined);
__decorate([
    JsonProperty("pimCode", String, false),
    __metadata("design:type", String)
], LanditoMenuEntry.prototype, "pimCode", undefined);
__decorate([
    JsonProperty("hasVisibleProducts", Boolean, false),
    __metadata("design:type", Boolean)
], LanditoMenuEntry.prototype, "hasVisibleProducts", undefined);
__decorate([
    JsonProperty("edito", Edito, true),
    __metadata("design:type", Edito)
], LanditoMenuEntry.prototype, "edito", undefined);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], LanditoMenuEntry.prototype, "menuEntryList", undefined);
LanditoMenuEntry = __decorate([
    JsonObject("LanditoMenuEntry"),
    __metadata("design:paramtypes", [Object])
], LanditoMenuEntry);

/**
 * @dynamic
 */
let EcommerceStoryMenuEntry = class EcommerceStoryMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.pimCode = undefined;
        this.hasVisibleProducts = undefined;
        this.edito = new Edito();
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "tid", undefined);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "parentId", undefined);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "type", undefined);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "eventType", undefined);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "name", undefined);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "path", undefined);
__decorate([
    JsonProperty("pimCode", String, false),
    __metadata("design:type", String)
], EcommerceStoryMenuEntry.prototype, "pimCode", undefined);
__decorate([
    JsonProperty("hasVisibleProducts", Boolean, true),
    __metadata("design:type", Boolean)
], EcommerceStoryMenuEntry.prototype, "hasVisibleProducts", undefined);
__decorate([
    JsonProperty("edito", Edito, true),
    __metadata("design:type", Edito)
], EcommerceStoryMenuEntry.prototype, "edito", undefined);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], EcommerceStoryMenuEntry.prototype, "menuEntryList", undefined);
EcommerceStoryMenuEntry = __decorate([
    JsonObject("EcommerceStoryMenuEntry"),
    __metadata("design:paramtypes", [Object])
], EcommerceStoryMenuEntry);

/**
 * @dynamic
 */
let StoryMenuEntry = class StoryMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        this.eventType = undefined;
        this.name = undefined;
        this.path = undefined;
        this.menuEntryList = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "tid", undefined);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "parentId", undefined);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "type", undefined);
__decorate([
    JsonProperty("eventType", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "eventType", undefined);
__decorate([
    JsonProperty("name", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "name", undefined);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], StoryMenuEntry.prototype, "path", undefined);
__decorate([
    JsonProperty("menuEntryList", []),
    __metadata("design:type", Array)
], StoryMenuEntry.prototype, "menuEntryList", undefined);
StoryMenuEntry = __decorate([
    JsonObject("StoryMenuEntry"),
    __metadata("design:paramtypes", [Object])
], StoryMenuEntry);

/**
 * @dynamic
 */
let SeparatorMenuEntry = class SeparatorMenuEntry {
    constructor(source) {
        this.tid = undefined;
        this.parentId = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("tid", String, true),
    __metadata("design:type", String)
], SeparatorMenuEntry.prototype, "tid", undefined);
__decorate([
    JsonProperty("parentId", String, true),
    __metadata("design:type", String)
], SeparatorMenuEntry.prototype, "parentId", undefined);
__decorate([
    JsonProperty("type", String, false),
    __metadata("design:type", String)
], SeparatorMenuEntry.prototype, "type", undefined);
SeparatorMenuEntry = __decorate([
    JsonObject("SeparatorMenuEntry"),
    __metadata("design:paramtypes", [Object])
], SeparatorMenuEntry);

/**
 * Format only needed fields for categorie suggestion to send to RDR
 */
let CategorySuggestion = class CategorySuggestion extends ModelObject {
    constructor() {
        super(...arguments);
        this.label = undefined;
        this.pimCode = undefined;
        this.results = undefined;
        this.categoriesId = undefined;
    }
};
__decorate([
    JsonProperty("label", String, true),
    __metadata("design:type", String)
], CategorySuggestion.prototype, "label", undefined);
__decorate([
    JsonProperty("pimCode", String, true),
    __metadata("design:type", String)
], CategorySuggestion.prototype, "pimCode", undefined);
__decorate([
    JsonProperty("results", Number, true),
    __metadata("design:type", Number)
], CategorySuggestion.prototype, "results", undefined);
__decorate([
    JsonProperty("categoriesId", String, true),
    __metadata("design:type", String)
], CategorySuggestion.prototype, "categoriesId", undefined);
CategorySuggestion = __decorate([
    JsonObject("CategorySuggestion")
], CategorySuggestion);

/**
 * Format only needed fields for product suggestion to send to RDR
 */
let ProductSuggestion = class ProductSuggestion extends ModelObject {
    constructor() {
        super(...arguments);
        this.label = undefined;
        this.sku = undefined;
        this.slug = undefined;
        this.productSetType = undefined;
        this.secondId = undefined;
        this.url = undefined;
    }
};
__decorate([
    JsonProperty("label", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "label", undefined);
__decorate([
    JsonProperty("sku", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "sku", undefined);
__decorate([
    JsonProperty("slug", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "slug", undefined);
__decorate([
    JsonProperty("productSetType", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "productSetType", undefined);
__decorate([
    JsonProperty("secondId", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "secondId", undefined);
__decorate([
    JsonProperty("url", String, true),
    __metadata("design:type", String)
], ProductSuggestion.prototype, "url", undefined);
ProductSuggestion = __decorate([
    JsonObject("ProductSuggestion")
], ProductSuggestion);

/**
 * Format only needed fields for search suggestions to send to RDR
 */
let SearchSuggestion = class SearchSuggestion extends ModelObject {
    constructor() {
        super(...arguments);
        this.categories = undefined;
        this.products = undefined;
    }
};
__decorate([
    JsonProperty("categories", [CategorySuggestion], true),
    __metadata("design:type", Array)
], SearchSuggestion.prototype, "categories", undefined);
__decorate([
    JsonProperty("products", [ProductSuggestion], true),
    __metadata("design:type", Array)
], SearchSuggestion.prototype, "products", undefined);
SearchSuggestion = __decorate([
    JsonObject("SearchSuggestion")
], SearchSuggestion);

export { BannerItem, BannersData, CategorySuggestion, EcommerceStoryMenuEntry, GridMenuEntry, LanditoMenuEntry, MenuEntryType, ProductSuggestion, SearchSuggestion, SeparatorMenuEntry, StoryMenuEntry };
